// import { HubState } from './store/sockets/reducer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import { Questionaire } from './Components/Questionaire';
import { GlobalServices } from './GlobalServices';
import DialogProvider from './providers/DialogProvider';
import DrawerProvider from './providers/DrawerProvider';
import store from './store/store';
import AppSettingsService from './Services/AppSettingsService';
import AuthService from './Services/AuthService';
import { adoptClientIdHandoff } from './Services/clientIdHandoff';
import { createTheme } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import { createRoot } from 'react-dom/client';
// import { runWithAdal } from 'react-adal';
// // import { authContext, getToken } from './adalConfig';

// const DO_NOT_LOGIN = true;

// (async () => {
//   try {
//     await getToken();
//   } catch (error) {
//     console.error(error);
//   } finally {
//     runWithAdal(authContext, () => {

//       // eslint-disable-next-line
//       require('./indexApp.tsx');

//     }, DO_NOT_LOGIN);
//   }
// })();

const theme = createTheme({
  palette: {
    primary: {
      main: `#1668dc`, // Auto-Master Blue
    },
    secondary: {
      main: `#e0e0e0`
    },
    error: {
      main: `#f50057`
    }
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard'
      }
    },
  },
});
export const successTheme = createTheme({
  palette: {
    primary: {
      main: green[600],
    },
    error: {
      main: `#f50057`
    }
  },
});
export const appSettings = new AppSettingsService();
export const authService = new AuthService(appSettings);
async function initializeApp() {
  // Before auth and before the first render, so no request can go out under the previously
  // stored client. Every HTTP helper here reads `clientId` from localforage per request, and
  // that read must see the DealerFlow360 hand-off. See Services/clientIdHandoff.
  await adoptClientIdHandoff();

  authService.handlePageLoadEvent().then(() => {
    // console.log("page load");
  });
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <DialogProvider>
          <DrawerProvider>
            <GlobalServices>
              <App authService={authService} />
            </GlobalServices>
          </DrawerProvider>
        </DialogProvider>
      </Provider>
    </ThemeProvider>
  );
}

// Jest loads this module transitively (utils import authService from the index),
// so don't boot the app in the jsdom test environment — it has no #root element.
if (process.env.NODE_ENV !== 'test') {
  initializeApp();
}
